<template>
  <div>
    <strong>
      {{streetAddress}} {{ city }} {{ state }} {{ zip }}
    </strong>
    <div v-if="!mapNotFound">
      <div :id="'map' + mapId" class="map-div"></div>
      Distance from:
      <div v-for="campus in campuses" :key="campus.name">
        <strong>{{campus.name}}</strong> : {{calculateDistance(campus) | number(2) }} miles
      </div>
    </div>
  </div>
</template>

<script>
import { OpenStreetMapProvider } from "leaflet-geosearch";
const provider = new OpenStreetMapProvider();

const L = require("leaflet");

export default {
  data() {
    return {
      latCoord: null,
      longCoord: null,
      maxZoom: 18,
      mapNotFound: false
    };
  },

  props: {
    // if displaying several maps on page, each must have unique ID
    mapId: {
      type: String,
      required: false
    },
    streetAddress: {
      type: String,
      required: true
    },
    city: {
      type: String,
      required: true
    },
    state: {
      type: String,
      required: true
    },
    zip: {
      required: true
    },
    zoom: {
      type: Number,
      required: false,
      default: 13
    },
    campuses: {
      type: Array,
      required: false,
      default: () => [
        { name: "Tempe Campus", latitude: 33.422031, longitude: -111.925779 },
        { name: "West Campus", latitude: 33.610605, longitude: -112.201108 },
        {
          name: "Downtown Phoenix Campus",
          latitude: 33.452953,
          longitude: -112.073454
        },
        {
          name: "Polytechnic Campus",
          latitude: 33.307249,
          longitude: -111.68398
        }
      ]
    }
  },

  methods: {
    createMap() {
      var map = L.map("map" + this.mapId).setView(
        [this.latCoord, this.longCoord],
        this.zoom
      );

      // tile layer
      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      }).addTo(map);

      // add marker
      L.marker([this.latCoord, this.longCoord]).addTo(map);
    },

    async getCoordinates(addressString) {
      console.log(addressString);
      var that = this;
      return new Promise((resolve, reject) => {
        provider.search({ query: addressString }).then(function(result) {
          if (result.length > 0) {
            that.longCoord = parseFloat(result[0].x);
            that.latCoord = parseFloat(result[0].y);
            that.createMap();
            resolve(result);
          } else {
            reject();
          }
        });
      });
    },

    // calculate straight line distance between campus and the desired location
    // in the future, would be preferable to find driving distance
    calculateDistance: function(campus) {
      var radlat1 = (Math.PI * this.latCoord) / 180;
      var radlat2 = (Math.PI * campus.latitude) / 180;
      var theta = this.longCoord - campus.longitude;
      var radtheta = (Math.PI * theta) / 180;
      var dist =
        Math.sin(radlat1) * Math.sin(radlat2) +
        Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
      if (dist > 1) {
        dist = 1;
      }
      dist = Math.acos(dist);
      dist = (dist * 180) / Math.PI;
      dist = dist * 60 * 1.1515;
      return dist;
    }
  },

  created: function() {
    var that = this;
    var addressString =
      this.streetAddress +
      ", " +
      this.city +
      ", " +
      this.state +
      ", " +
      this.zip;
    this.getCoordinates(addressString).catch(function() {
      // try again, this time attempting to remove 'suite' or 'ste' from the address
      var shortenedStreetAddress = that.streetAddress.replace(
        /(Suite|Ste\.|, Suite|, Ste\.).([0-9a-zA-Z])*.*/,
        ""
      );
      if (shortenedStreetAddress.length < that.streetAddress.length) {
        addressString =
          shortenedStreetAddress +
          ", " +
          that.city +
          ", " +
          that.state +
          ", " +
          that.zip;
        that.getCoordinates(addressString).catch(function() {
          that.mapNotFound = true;
        });
      } else {
        that.mapNotFound = true;
      }
    });
  }
};
</script>

<style scoped>
.map-div {
  height: 180px;
}

.map-not-found {
  font-style: italic;
}
</style>
